export const useTimer = () => {
  const timer = ref<NodeJS.Timeout | null>(null)
  const secondsToEnd = ref(0)

  const timeToEnd = computed(() => {
    const minutes = Math.floor(secondsToEnd.value / 60)
    const seconds = Math.floor(secondsToEnd.value - minutes * 60)

    const toTime = (value: number) => value.toString().padStart(2, '0')

    return toTime(minutes) + ':' + toTime(seconds)
  })

  function start(seconds: number, onOver?: (seconds: number) => void) {
    secondsToEnd.value = seconds

    if (import.meta.client) {
      timer.value = setInterval(() => {
        secondsToEnd.value--
        if (secondsToEnd.value <= 1) {
          stop()
          onOver?.(seconds)
        }
      }, 1000)
    }
  }

  onBeforeUnmount(() => {
    if (timer.value) {
      clearInterval(timer.value)
    }
  })

  function stop() {
    if (!timer.value) {
      return
    }

    clearInterval(timer.value)
    secondsToEnd.value = 0
  }

  return {
    start,
    stop,
    timeToEnd,
    secondsToEnd,
  }
}
